import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

function loadView(view) {
  // which is lazy-loaded when the route is visited.
  return () => import(`@/views/${view}.vue`);
}

export default new Router({
  mode: "history",
  linkExactActiveClass: "showActive",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      authName: "login",
      whileRoute: true,
      txtName: "登录",
      component: loadView("login/login"),
    },
  ],
});
